if(!__webpack_require__.federation){
	__webpack_require__.federation = {
		initOptions: {"name":"you-payment","remotes":[]},
		chunkMatcher: function(chunkId) {return true},
		rootOutputDir: "",
		initialConsumes: undefined,
		bundlerRuntimeOptions: {}
	};
}